import { React, useState } from "react";
import { Outlet } from "react-router-dom";



//styles
import './styles/index.scss';

// Bootstrap JS is required for some functionality
import "bootstrap/dist/js/bootstrap.bundle.min";

function getSessionStorageOrDefault(key, defaultValue) {
    const stored =  sessionStorage.getItem(key);
    if (!stored) {
      return defaultValue;
    }
    return JSON.parse(stored);

}

function UserManagement() {

    // eslint-disable-next-line no-unused-vars
    const [userDetails, setUserDetails] = useState(
        getSessionStorageOrDefault('userDetails', null)
    );

    const found_view_usermanagement = userDetails?.permissions.find(permission => permission.codename === 'view_usermanagement') || false;
    
    return (
        <>
            { found_view_usermanagement === false && <h1 className="h1 m-5"> You do not have permission to view the user management module.</h1> }

            { found_view_usermanagement &&
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-9 ms-sm-auto col-lg-10 px-md-4 container-fluid">
                            <Outlet />
                        </div>
                    </div>
                </div>
            }
        </>
    );
}


export default UserManagement;